<template>
  <div class="asd20-people-filters">
    <!-- <Asd20MultiselectInput
      :value="selectedOrganizationOptions"
      :items="organizationOptions"
      icon="map"
      label="Choose organizations"
      hide-label
      item-label="label"
      item-value="value"
      @input="selectedOrganizations = $event.map(o => o.value)"
    /> -->

    <asd20-viewport id="Type" scrollable>
      <asd20-accordion
        :badge="selectedJobTypes.length > 0 ? 0 : -1"
        opened
        label="Job Types"
        expanded
      >
        <asd20-checkbox-list
          :options="jobTypeOptions"
          :checked-values="selectedJobTypes"
          @input="selectedJobTypes = $event"
        />
      </asd20-accordion>

      <!-- <asd20-accordion
        :badge="selectedOffices.length > 0 ? 0 : -1"
        label="Offices"
        expanded
      >
        <asd20-checkbox-list
          :options="officeOptions"
          :checked-values="selectedOffices"
          @input="selectedOffices = $event"
        />
      </asd20-accordion> -->
    </asd20-viewport>
  </div>
</template>

<script>
import { get, sync } from 'vuex-pathify'
import Asd20Accordion from '@asd20/ui/src/components/molecules/Asd20Accordion'
import Asd20CheckboxList from '@asd20/ui/src/components/molecules/Asd20CheckboxList'
import Asd20Viewport from '@asd20/ui/src/components/atoms/Asd20Viewport'

export default {
  name: 'Asd20PeopleFilters',
  components: {
    Asd20Accordion,
    Asd20CheckboxList,
    Asd20Viewport,
  },
  props: {},

  computed: {
    organizationOptions: get('people/organizationOptions'),
    selectedOrganizations: sync('people/selectedOrganizations'),
    jobTypeOptions: get('people/jobTypeOptions'),
    selectedJobTypes: sync('people/selectedJobTypes'),
    officeOptions: get('people/officeOptions'),
    selectedOffices: sync('people/selectedOffices'),
    selectedOrganizationOptions() {
      return this.organizationOptions.filter(
        o => this.selectedOrganizations.indexOf(o.value) > -1
      )
    },
  },
}
</script>

<style lang="scss">
@import '@asd20/ui/src/design/_variables.scss';

.asd20-people-filters {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-grow: 1;

  .asd20-viewport {
    // padding-top: space(1);
    margin-bottom: auto;
    flex-grow: 0;
  }

  .asd20-checkbox-list {
    padding-top: space(0.25);
    padding-bottom: space(0.25);
  }

  .asd20-checkbox {
    padding-left: space(1);
    padding-right: space(1);
    width: auto;
  }
  .asd20-multiselect-input {
    margin: space(0.25) space(0.5) space(0.25) 0;
  }
}

@media (min-width: 1024px) {
  .asd20-people-filters {
    .asd20-multiselect-input {
      margin: 0 space(1) space(1) 0;
    }
  }
}
</style>
